import { Injector, Injectable, Inject } from '@angular/core';
import { Http, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { ABaseService } from './a-base.service';

@Injectable()
export class BaseService extends ABaseService {
    constructor(injector: Injector) {
        super(injector);
    }
}
